module.exports = __webpack_public_path__ + "static/media/collection-error-notification-icon.aff81a53.svg";